/* TATIDA — mini juego de patos escondidos («la web también juega»)
   Los patos .td-egg sueltan un bocadillo al encontrarlos; contador fijo
   y, al completar, modal de premio: el Pato Dorado nº 101 (palabra secreta
   GOLDEN DUCK en la nota del pedido). El progreso persiste en localStorage
   para que el 3/3 se pueda lograr entre visitas. */
(function () {
  /* la etiqueta de la PDP se renderiza en la columna de info (custom_liquid);
     se reubica sobre la galería, donde el mockup la pinta */
  var tag = document.querySelector('.td-pdp-tag');
  var media = document.querySelector('.product__media-wrapper');
  if (tag && media) media.appendChild(tag);

  /* cantidad dentro de la fila de botones: qty + Add to cart en fila 1,
     Buy with Shop a ancho completo en fila 2 (como el mockup) */
  var qty = document.querySelector('.product-form__quantity') || document.querySelector('.product-form__input--quantity');
  var btns = document.querySelector('.product-form__buttons');
  if (qty && btns) btns.insertBefore(qty, btns.firstChild);

  /* primer acordeón (What's inside) abierto por defecto */
  var acc = document.querySelector('.product__accordion details');
  if (acc) acc.setAttribute('open', '');

  /* la descripción larga se pliega en un acordeón; el texto sigue
     server-rendered en el HTML (SEO/AEO intacto), solo cambia la presentación */
  var desc = document.querySelector('.product__description');
  if (desc) {
    var d = document.createElement('details');
    d.className = 'accordion td-desc-acc';
    d.innerHTML = '<summary><span class="td-desc-acc__title">About this set</span></summary>';
    desc.parentNode.insertBefore(d, desc);
    d.appendChild(desc);
  }

  /* ── el juego ─────────────────────────────────────────────── */
  var KEY_FOUND = 'td_hunt_found';
  var KEY_WON = 'td_hunt_won';

  function loadFound() {
    try { return JSON.parse(localStorage.getItem(KEY_FOUND)) || []; }
    catch (e) { return []; }
  }
  function saveFound(list) {
    try { localStorage.setItem(KEY_FOUND, JSON.stringify(list)); } catch (e) {}
  }
  function eggKey(egg) {
    var m = egg.className.match(/td-egg--(\w+)/);
    return m ? m[1] : 'egg';
  }

  /* pato dorado nº 101 (versión oro de la mascota) */
  var GOLD_DUCK =
    '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 240 240" role="img" aria-label="The golden duck, number 101">' +
    '<ellipse cx="120" cy="162" rx="70" ry="54" fill="#EFBF2A"/>' +
    '<circle cx="120" cy="84" r="50" fill="#EFBF2A"/>' +
    '<path d="M112 38 Q120 26 132 34 Q124 36 122 44 Z" fill="#D19E16"/>' +
    '<ellipse cx="56" cy="160" rx="16" ry="30" fill="#D19E16" transform="rotate(14 56 160)"/>' +
    '<ellipse cx="184" cy="160" rx="16" ry="30" fill="#D19E16" transform="rotate(-14 184 160)"/>' +
    '<ellipse cx="120" cy="106" rx="21" ry="11" fill="#E8A61B"/>' +
    '<ellipse cx="120" cy="102.5" rx="16" ry="7" fill="#F2BC45"/>' +
    '<circle cx="101" cy="78" r="6.5" fill="#33291F"/>' +
    '<circle cx="139" cy="78" r="6.5" fill="#33291F"/>' +
    '<circle cx="103.3" cy="75.8" r="2" fill="#FFFFFF"/>' +
    '<circle cx="141.3" cy="75.8" r="2" fill="#FFFFFF"/>' +
    '<circle cx="120" cy="168" r="29" fill="#FDF8EE"/>' +
    '<text x="120" y="179" text-anchor="middle" font-family="\'Baloo 2\',\'Arial Rounded MT Bold\',system-ui,sans-serif" font-weight="800" font-size="27" fill="#33291F">101</text>' +
    '<ellipse cx="96" cy="216" rx="15" ry="7" fill="#E8A61B"/>' +
    '<ellipse cx="144" cy="216" rx="15" ry="7" fill="#E8A61B"/>' +
    '<path d="M52 62 l4 10 10 4 -10 4 -4 10 -4 -10 -10 -4 10 -4 Z" fill="#FDD547"/>' +
    '<path d="M192 96 l3 7 7 3 -7 3 -3 7 -3 -7 -7 -3 7 -3 Z" fill="#FDD547"/>' +
    '</svg>';

  var modal = null;
  function buildModal() {
    if (modal) return modal;
    modal = document.createElement('div');
    modal.className = 'td-hunt-modal';
    modal.innerHTML =
      '<div class="td-hunt-modal__overlay" data-close></div>' +
      '<div class="td-hunt-modal__card" role="dialog" aria-modal="true" aria-labelledby="td-prize-title">' +
      '<button class="td-hunt-modal__close" type="button" aria-label="Close" data-close>&times;</button>' +
      '<div class="td-hunt-modal__duck">' + GOLD_DUCK + '</div>' +
      '<p class="td-hunt-modal__kicker">Secret unlocked</p>' +
      '<h2 class="td-hunt-modal__title" id="td-prize-title">You found duck number 101</h2>' +
      '<p class="td-hunt-modal__body">Three ducks found. Sharp eyes. There is one duck we never put in any set: the golden one. Write the secret word in the order note at checkout and it will sneak into your box, free.</p>' +
      '<div class="td-hunt-modal__code">GOLDEN DUCK</div>' +
      '<a class="td-hunt-modal__cta button" href="/collections/hunt-games">To the Hunt Games</a>' +
      '<p class="td-hunt-modal__fine">One golden duck per order. Our little secret.</p>' +
      '</div>';
    document.body.appendChild(modal);
    modal.addEventListener('click', function (ev) {
      if (ev.target.hasAttribute('data-close')) closeModal();
    });
    document.addEventListener('keydown', function (ev) {
      if (ev.key === 'Escape') closeModal();
    });
    return modal;
  }
  function openModal() {
    buildModal();
    void modal.offsetWidth; /* reflow síncrono: dispara la transición sin carrera con el cierre */
    modal.classList.add('on');
    var card = modal.querySelector('.td-hunt-modal__card');
    if (card) { card.setAttribute('tabindex', '-1'); card.focus(); }
  }
  function closeModal() {
    if (modal) modal.classList.remove('on');
  }

  var chip = document.getElementById('td-hunt-chip');
  var chipN = document.getElementById('td-hunt-n');
  var chipT = document.getElementById('td-hunt-total');

  function setChipWon() {
    if (!chip) return;
    chip.classList.add('on', 'won');
    var spans = chip.querySelectorAll(':scope > span');
    if (spans.length >= 2) { spans[0].textContent = '🏆'; spans[1].textContent = 'Golden duck unlocked'; }
    chip.setAttribute('role', 'button');
    chip.setAttribute('tabindex', '0');
    chip.setAttribute('aria-label', 'You found all the ducks. See your prize.');
    chip.addEventListener('click', openModal);
    chip.addEventListener('keydown', function (ev) {
      if (ev.key === 'Enter' || ev.key === ' ') { ev.preventDefault(); openModal(); }
    });
  }

  var won = false;
  try { won = localStorage.getItem(KEY_WON) === '1'; } catch (e) {}

  /* solo cuentan los patos visibles (en móvil el del héroe está oculto:
     sin este filtro el 3/3 sería imposible en pantallas pequeñas) */
  var eggs = Array.prototype.filter.call(
    document.querySelectorAll('.td-egg'),
    function (egg) { return egg.offsetParent !== null; }
  );

  if (!eggs.length) {
    /* páginas sin patos: si ya ganó, el chip sigue dando acceso al premio */
    if (won) setChipWon();
    return;
  }

  var stored = loadFound();
  var total = eggs.length;
  if (chipT) chipT.textContent = total;

  function countFound() {
    return eggs.filter(function (e) { return e.classList.contains('found'); }).length;
  }

  /* restaurar progreso de visitas anteriores */
  eggs.forEach(function (egg) {
    if (stored.indexOf(eggKey(egg)) !== -1) egg.classList.add('found');
  });
  var initial = countFound();
  if (initial > 0 && chip) { chip.classList.add('on'); chipN.textContent = initial; }
  if (won) setChipWon();

  eggs.forEach(function (egg) {
    function find() {
      if (egg.classList.contains('found')) return;
      egg.classList.add('found', 'show');
      setTimeout(function () { egg.classList.remove('show'); }, 2600);
      var list = loadFound();
      if (list.indexOf(eggKey(egg)) === -1) { list.push(eggKey(egg)); saveFound(list); }
      var n = countFound();
      if (chip) { chip.classList.add('on'); chipN.textContent = n; }
      if (n === total && !won) {
        won = true;
        try { localStorage.setItem(KEY_WON, '1'); } catch (e) {}
        setChipWon();
        setTimeout(openModal, 900);
      }
    }
    egg.addEventListener('click', find);
    egg.addEventListener('keydown', function (ev) {
      if (ev.key === 'Enter' || ev.key === ' ') { ev.preventDefault(); find(); }
    });
  });
})();